import { Link } from "react-router-dom";

export function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-[#DEDBD3] bg-[#F9F8F6]/60">
      <div className="max-w-6xl mx-auto px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[#8A877F]">
        <p>© {new Date().getFullYear()} Dap Ledger — honor, not credit.</p>
        <div className="flex items-center gap-5">
          <Link
            to="/terms"
            data-testid="footer-terms-link"
            className="hover:text-[#1B4D3E] transition-colors"
          >
            Terms of Service
          </Link>
          <Link
            to="/privacy"
            data-testid="footer-privacy-link"
            className="hover:text-[#1B4D3E] transition-colors"
          >
            Privacy Policy
          </Link>
        </div>
      </div>
    </footer>
  );
}
